import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  START_DATE_FORMAT,
  TIME_FORMAT,
} from "../core/constants";
import { FilterItemValue } from "../modules/filters/filters.types";

export const formatDateDDMMYY = (date: Date | string) => {
  if (!date) return null;
  return dayjs(date).format(DATE_FORMAT);
};

export const formatDateTime = (date: Date | string) => {
  if (!date) return null;
  return dayjs(date).format(DATE_TIME_FORMAT);
};

export const formatTime = (date: Date | string) => {
  if (!date) return null;
  return dayjs(date).format(TIME_FORMAT);
};

export const disableFuture = (current: dayjs.Dayjs) =>
  current && current.valueOf() > Date.now();
export const disablePast = (current: dayjs.Dayjs) =>
  current && current.valueOf() < Date.now();

export const formatDateFilterView = (date: FilterItemValue) => {
  dayjs?.extend?.(customParseFormat);

  if (!date) {
    return null;
  }

  return dayjs(date as string, START_DATE_FORMAT);
};

export const formatDateFilterApi = (date: FilterItemValue) => {
  if (!date) {
    return null;
  }

  return (date as Dayjs).format(START_DATE_FORMAT);
};
